import React from 'react'

const TableHeader = ({options}) => {
  return (
                <thead className=" text-light">
                    <tr className="text-light bg-dark text-capitalize display-3" style={{fontSize : "2rem"}}>
                        {options.map((option , index) => (
                            <th scope="col" className="text-capitalize display-3 " style={{fontSize : "38%"}} key={index}>{option}</th>
                        ))}
                    </tr>
                  </thead>
  )
}

export default TableHeader